/* user modules */
angular.module('bmsApp.responses', ['ui.router'])
	.config(['$stateProvider', '$urlRouterProvider', 'BMSPermission', function config($stateProvider, $urlRouterProvider, BMSPermission) {
			$stateProvider

				.state('main.500', {
					url: '/error',
					params: {errorData: null},
					views: {
						'': {
							templateUrl: 'ng/responses/500.html',
							controller: 'Response500Ctrl'
						},
					},
				})
				
				
				.state('main.401', {
					url: '/401',
					views: {
						'': {
							templateUrl: 'ng/responses/401.html',
						},
					},
				})
				
				.state('main.403', {
					url: '/403',
					views: {
						'': {
							templateUrl: 'ng/responses/403.html',
						},
					},
				})
				
				.state('main.404', {
					url: '/404',
					views: {
						'': {
							templateUrl: 'ng/responses/404.html',
						},
					},
				})
				
			
				

		}]);



